<script>
import Swal from "sweetalert2";
import _ from "lodash";
// TODO: path get auto increment que es el que existe
// Todo: path get por ultimo directorio

export default {
  props: {
    fileTypes: {
      type: Array,
      default: () => [], // ["image/jpeg", "image/png"], // Tipos MIME por defecto
    },
    urlDir: {
      type: String,
      default: () => "",
      required: true,
    },
    injectData: {
      type: Object,
      default: () => {},
    },
    pathPost: {
      type: String,
      required: true,
    },
    pathGet: {
      type: String,
      required: true,
    },
    autoIncrement: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      file: null,
      name: null,
      imageUrl: null,
      typeFile: null,
      loader: false,
      isHovered: false,
      progreso: 0,
      progresoSimulado: 0,
      simulacionActiva: false,
      tiempoInicioCarga: null,
      progresoRealRapido: false,
    };
  },
  computed: {
    backgroundStyle() {
      if (this.imageUrl) {
        return {
          backgroundImage: `url("${this.imageUrl}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
        };
      }
      return {};
    },
    isFile() {
      return this.file ? true : false;
    },
    fileBackground() {
      if (this.file) {
        let backgroundImage = this.imageUrl ? `url("${this.imageUrl}")` : "";
        return {
          backgroundImage: backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        };
      }
      return {};
    },
    extensionOfFileTypes() {
      return this.fileTypes.map((elment) => {
        return elment.substring(elment.lastIndexOf("/") + 1);
      });
    },
  },
  methods: {
    handleFilesSisi(data) {
      this.$emit("handleFilesSisi", data);
    },
    handleFilesSisi2(data) {
      this.$emit("handleFilesSisi2", data);
    },
    handleMouseOver() {
      // console.log("hover over");
      this.isHovered = true;
    },
    handleMouseLeave() {
      // console.log("hover leave");
      this.isHovered = false;
    },
    quitarTildesYEspacios(input) {
      let sinTildes = _.deburr(input);
      let sinEspacios = sinTildes.replace(/\s+/g, "");
      return sinEspacios;
    },
    restaurar() {
      this.file = null;
      this.imageUrl = null;
      this.progreso = 0;
      this.progresoSimulado = 0;
      this.simulacionActiva = false;
      this.tiempoInicioCarga = null;
      this.progresoRealRapido = false;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    handleDrop(event) {
      const selectedFile = event.dataTransfer.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    validateAndProcessFile(selectedFile) {
      console.log(selectedFile.type);
      if (
        this.fileTypes.includes(selectedFile.type) &&
        selectedFile.name.split(".").length <= 2
      ) {
        this.file = selectedFile;
        this.typeFile = this.file.name.substring(
          this.file.name.lastIndexOf("."),
        );
        this.name = this.file.name;
        //Coloca de fondo la imagen siempre y cuando sea una imagen
        if (selectedFile.type.startsWith("image/")) {
          this.imageUrl = URL.createObjectURL(selectedFile);
          console.log("selectedFile", selectedFile);
        }
      } else {
        console.error("Tipo de archivo no válido.");

        if (!this.fileTypes.includes(selectedFile.type)) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Tipo de archivo no válido.",
            confirmButtonText: "Aceptar",
          });
        }

        if (selectedFile.name.split(".").length > 2) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "El nombre del archivo no puede contener puntos.",
            confirmButtonText: "Aceptar",
          });
        }

        this.file = null;
        this.imageUrl = null;
      }
      this.$refs.fileInput.value = "";
    },
    async onUpload() {
      try {
        //Consultar la base de datos la ultima imagen
        let count = 0;
        let dataGet;
        this.loader = true;
        // this.$isLoading(true);

        try {
          const responseGet = await this.$store.getters.fetchGet({
            path: this.pathGet,
          });
          dataGet = await responseGet.json();
          count = dataGet.length.toString().padStart(4, "0");
        } catch {
          count = [].length.toString().padStart(4, "0");
        }

        const newPath = this.quitarTildesYEspacios(this.urlDir);
        const lastDirectory = newPath.substring(newPath.lastIndexOf("/") + 1);
        const filename = `${lastDirectory}_${count}${this.typeFile}`;
        const urlImg = newPath.split("/").join("|");

        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("remoteFilePath", urlImg);
        formData.append("FileName", filename);
        formData.append("fileType", this.file.type);

        this.tiempoInicioCarga = Date.now();
        this.iniciarProgresoSimulado();

        const isSave = await this.$store.dispatch("hl_post_file_axios", {
          path: "CargaMultimedia/UploadFile",
          data: formData,
          onProgress: (percent) => {
            this.progreso = percent;
            if (percent >= 50 && !this.progresoRealRapido) {
              const tiempoTranscurrido = Date.now() - this.tiempoInicioCarga;
              if (tiempoTranscurrido < 2000) {
                this.progresoRealRapido = true;
                this.acelerarProgresoSimulado();
              }
            }
            if (percent < 50) {
              this.actualizarProgresoSimulado(percent);
            }
          },
        });

        await new Promise((resolve) => setTimeout(resolve, 500));
        this.completarProgresoSimulado();

        if (isSave && isSave.respuesta) {
          // enviar file a sisi pesv
          // fase 1
          this.handleFilesSisi({
            file: this.file,
            pasoId: this.injectData.PasoId,
          });

          // fase 2
          this.handleFilesSisi2({
            file: this.file,
            numeroEvidencia: this.injectData.NumeroEvidencia,
            form: this.injectData.Form,
          });

          const url = "https://helexiumfiles.com/" + newPath + "/" + filename;

          const data = {
            ...this.injectData,
            NombreArchivo: filename,
            // descripcion: filename,
            // urlDir: newPath,
            UrlArchivo: url,
          };
          console.log("data", data);

          if (this.autoIncrement || dataGet.length == 0) {
            this.$store.getters
              .fetchPost({ path: this.pathPost, data: data })
              .then((response) => {
                // this.$isLoading(false);

                // console.log("response", response);
                if (response.ok) {
                  return response.json();
                }
                throw new Error("Error en el backend o DB");
              })
              .then((result) => {
                // this.$isLoading(false);

                Swal.fire({
                  icon: "success",
                  title: "Se ha guardado el documento",
                  text: `El documento "${this.name}" ha sido cargado`,
                  confirmButtonText: "Aceptar",
                }).then(() => {
                  this.restaurar();
                });

                this.$emit("onUpload", result);
              })
              .catch((error) => {
                // this.$isLoading(false);

                throw new Error(error);
              });
          } else {
            data["id"] = dataGet[0].id;

            this.$store.getters
              .fetchPut({ path: `${this.pathPost}/${data.id}`, data: data })
              .then((response) => {
                // this.$isLoading(false);

                // console.log("response", response);
                if (response.ok) {
                  return response.json();
                }
                throw new Error("Error en el backend o DB");
              })
              .then((result) => {
                // this.$isLoading(false);

                Swal.fire({
                  icon: "success",
                  title: "Se ha guardado el documento",
                  text: `El documento "${this.name}" ha sido cargado`,
                  confirmButtonText: "Aceptar",
                }).then(() => {
                  this.restaurar();
                });

                this.$emit("onUpload", result);
              })
              .catch((error) => {
                // this.$isLoading(false);

                throw new Error(error);
              });
          }
        } else {
          // this.$isLoading(false);

          throw new Error(
            (isSave && isSave.mensaje) ||
              "Error al guardar el archivo en el servidor. Por favor, intentelo de nuevo",
          );
        }
      } catch (error) {
        // this.$isLoading(false);

        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message,
          confirmButtonText: "Aceptar",
        });
      } finally {
        this.loader = false;
        this.progreso = 0;
        this.progresoSimulado = 0;
        this.simulacionActiva = false;
        this.tiempoInicioCarga = null;
        this.progresoRealRapido = false;
      }
    },
    iniciarProgresoSimulado() {
      this.progresoSimulado = 0;
      this.simulacionActiva = true;
      this.simulacionProgreso();
    },
    simulacionProgreso() {
      if (!this.simulacionActiva) return;
      let incremento, intervalo;
      if (this.progresoRealRapido) {
        if (this.progresoSimulado < 30) {
          incremento = 25;
          intervalo = 100;
        } else if (this.progresoSimulado < 70) {
          incremento = 30;
          intervalo = 80;
        } else {
          incremento = 20;
          intervalo = 120;
        }
      } else {
        if (this.progresoSimulado < 30) {
          incremento = 8;
          intervalo = 300;
        } else if (this.progresoSimulado < 70) {
          incremento = 12;
          intervalo = 250;
        } else {
          incremento = 6;
          intervalo = 400;
        }
      }
      this.progresoSimulado = Math.min(this.progresoSimulado + incremento, 100);
      if (this.progresoSimulado < 100 && this.simulacionActiva) {
        setTimeout(() => this.simulacionProgreso(), intervalo);
      }
    },
    actualizarProgresoSimulado(progresoReal) {
      if (progresoReal < 50 && progresoReal > this.progresoSimulado) {
        this.progresoSimulado = progresoReal;
      }
    },
    acelerarProgresoSimulado() {
      // Carga rápida detectada, el intervalo ya usa progresoRealRapido en simulacionProgreso
    },
    completarProgresoSimulado() {
      this.simulacionActiva = false;
      this.progresoSimulado = 100;
      setTimeout(() => {
        if (this.progresoSimulado === 100) {
          this.progresoSimulado = 0;
        }
      }, 2000);
    },
  },
};
</script>

<template>
  <form @submit.prevent="onUpload">
    <slot name="header"> </slot>
    <input
      type="file"
      @change="handleFileChange"
      ref="fileInput"
      style="display: none"
    />
    <div
      class="dropzone"
      :class="{ 'is-file': isFile }"
      :style="fileBackground"
      @click="triggerFileInput"
      @drop.prevent="handleDrop"
      @dragover.prevent
      @dragenter.prevent
      @mouseover="handleMouseOver"
      @mouseleave="handleMouseLeave"
    >
      <div v-if="loader" class="loader"></div>
      <div class="overlay" v-if="imageUrl"></div>
      <div v-if="!file" class="d-flex flex-column align-items-center">
        <i
          :class="[
            'fas fa-cloud-arrow-up text-white-50',
            isHovered && 'fa-beat',
          ]"
          style="font-size: 2rem"
        ></i>
        <br />
        Haz clic o arrastra un archivo aquí.
        <!-- De tipo {{ extensionOfFileTypes }} -->
      </div>
      <div
        v-else
        class="d-flex flex-column align-items-center"
        style="z-index: 3"
      >
        <i
          :class="`fas fa-file-circle-check ${loader && 'fa-bounce'}`"
          style="font-size: 2rem"
        ></i>
        <br />
        <span>
          El documento "
          <span class="text-primary font-weight-bold">{{ name }}</span> " ha
          sido cargado
        </span>
      </div>
    </div>
    <slot name="prevFooter"> </slot>
    <transition name="fade-slide" appear>
      <div
        v-if="progresoSimulado > 0"
        class="progress-container d-flex align-items-center"
        style="width: 100%; padding: 0 1rem; margin-top: 1rem; gap: 1rem"
      >
        <progress
          :value="progresoSimulado"
          max="100"
          class="progress-minimal"
        ></progress>
        <span class="progress-percentage">{{ progresoSimulado }}%</span>
      </div>
    </transition>
    <div class="actions mt-2" v-if="file">
      <vs-button
        v-b-tooltip.hover
        title="Cargar archivo"
        icon
        type="submit"
        :disabled="loader"
        :upload="loader"
      >
        <i class="fas fa-cloud-arrow-up"></i>
      </vs-button>

      <vs-button
        v-b-tooltip.hover
        title="Cancelar"
        danger
        icon
        @click.prevent="restaurar"
        :disabled="loader"
      >
        <i class="fas fa-xmark-circle"></i>
      </vs-button>
    </div>
  </form>
</template>

<style scoped>
form {
  width: 100%;
  min-height: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dropzone {
  width: 100%;
  min-height: 150px;
  height: 80%;
  border: 2px dashed #ccc;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  transition: 0.3s all;

  &:hover {
    background-color: #ececec;
  }

  .dark &:hover {
    background-color: #131416;
  }
}

.is-file {
  background-color: #ececec;

  .dark & {
    background-color: #131416;
  }
}

.loader {
  width: 100%;
  height: 100%;
  position: absolute;
  /* background-color: rgba(27, 75, 141, 0.5); */
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 2;
}

.actions {
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.progress-container {
  transition: all 0.3s ease-in-out;
}

.progress-minimal {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  border: none;
  background-color: #e9ecef;
  -webkit-appearance: none;
  appearance: none;
}

.dark .progress-minimal {
  background-color: #131416;
}

.progress-minimal::-webkit-progress-bar {
  background-color: #e9ecef;
  border-radius: 4px;
}

.dark .progress-minimal::-webkit-progress-bar {
  background-color: #131416;
}

.progress-minimal::-webkit-progress-value {
  background-color: #1a5cff;
  border-radius: 4px;
  transition: width 0.3s ease-in-out;
}

.progress-minimal::-moz-progress-bar {
  background-color: #1a5cff;
  border-radius: 4px;
  transition: width 0.3s ease-in-out;
}

.progress-percentage {
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 3rem;
  text-align: right;
}

.fade-slide-enter-active {
  transition: all 0.4s ease-out;
}

.fade-slide-leave-active {
  transition: all 0.3s ease-in;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
